import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/trivia`;

async function getTrivia(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/`);

    return data;
  } catch (e) {
    throw e;
  }
}

async function getQuestions(token, id) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/questions/${id}`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function submitAnswer(token, answerData) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}/question`, answerData);
    return data;
  } catch (e) {
    throw e;
  }
}

async function postTriviaVoucher({ token, voucher, triviaId }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.post(`${SERVER_URL}/trivia/voucher/`, {
      voucher,
      triviaId,
    });

    return data;
  } catch (e) {
    throw e;
  }
}

async function postTriviaUserDisqualified({ token, triviaId }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.post(`${SERVER_URL}/trivia/disqualified/`, {
      triviaId,
    });

    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemReward({
  token,
  triviaId,
  rewardType,
  value,
  region,
  officeLocation,
}) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  try {
    const { data } = await axios.post(`${SERVER_URL}/trivia/redeem/`, {
      triviaId,
      rewardType,
      value,
      region,
      officeLocation,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemRewardOnground({ token, triviaId, redemptionCode }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${SERVER_URL}/trivia/redeem/onground/`, {
      triviaId,
      redemptionCode,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

async function getHistory(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/history`);
    return data;
  } catch (e) {
    throw e;
  }
}
async function fetchRewardAvailability({ token, triviaId }) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/reward-stock/${triviaId}`);
    return data;
  } catch (e) {
    throw e;
  }
}

export default {
  postTriviaVoucher,
  getTrivia,
  getQuestions,
  submitAnswer,
  postTriviaUserDisqualified,
  redeemReward,
  redeemRewardOnground,
  getHistory,
  fetchRewardAvailability,
};
